import {createStore} from "effector";

export const $blacklist = createStore([])

export const $addUserModal = createStore(false)

export const $showUpload = createStore(false)